/** @jsx jsx */
import React from "react"
import PropTypes from "prop-types"
import { jsx } from "@emotion/core"
import { typography } from "../styles"

export const Testimonial = ({ children, text, from, company, ...props }) => {
  // “string”
  return (
    <blockquote
      css={{
        hangingPunctuation: "first force-end last",
        padding: "1rem",

        fontFamily: typography.MUSEO,

        fontWeight: 700,
        fontSize: "1rem",
        lineHeight: 1.2,

        textAlign: "left",
      }}
      {...props}
    >
      {children ? <>&ldquo;{children}&rdquo;</> : <>&ldquo;{text}&rdquo;</>}
      <br />
      <br />
      <cite
        css={{
          display: "block",
          fontFamily: typography.UNIVIA,
          fontWeight: "normal",
          fontStyle: "italic",
          textAlign: "right",
          fontSize: "0.9rem",
          lineHeight: 1.4,
        }}
      >
        {from && `— ${from}`}

        {company && (
          <>
            {" "}
            <br /> {company}{" "}
          </>
        )}
      </cite>
    </blockquote>
  )
}
Testimonial.propTypes = {
  text: PropTypes.string,
  by: PropTypes.string,
  children: PropTypes.any,
}

export default Testimonial
